import { MedicalPrescriptionDocumentKey } from "./medical-prescription-document-key";
import { PractitionerRegistration } from "./practitioner-registration";

export class MedicalPrescription {
  private quantity: number = 0;
  private medicalPrescriptionDate: string;
  private medicalPrescriptionInsertionDate: string;
  private practitionerRegistration: PractitionerRegistration;
  private medicalPrescriptionDocumentKey: MedicalPrescriptionDocumentKey;
  private MedicalPrescriptionDocument: string;
  private medicalPrescriptionScanUrl: string;
  private medicalPrescriptionStatus: string;

  constructor() {
    this.practitionerRegistration = new PractitionerRegistration();
    this.medicalPrescriptionDocumentKey = new MedicalPrescriptionDocumentKey();
    this.medicalPrescriptionDate = "";
    this.medicalPrescriptionInsertionDate = "";
  }

  public setQuantity(value: number) {
    this.quantity = value;
  }

  public getQuantity(): number {
    return this.quantity;
  }

  public setMedicalPrescriptionDate(value: string) {
    this.medicalPrescriptionDate = value;
  }

  public getMedicalPrescriptionDate(): string {
    return this.medicalPrescriptionDate;
  }

  public setMedicalPrescriptionInsertionDate(value: string): void {
    this.medicalPrescriptionInsertionDate = value;
  }

  public getMedicalPrescriptionInsertionDate(): string {
    return this.medicalPrescriptionInsertionDate;
  }

  public setPractitionerRegistration(value: PractitionerRegistration) {
    this.practitionerRegistration = value;
  }

  public getPractitionerRegistration(): PractitionerRegistration {
    return this.practitionerRegistration;
  }

  public setMedicalPrescriptionDocumentKey(value: MedicalPrescriptionDocumentKey) {
    this.medicalPrescriptionDocumentKey = value;
  }

  public getMedicalPrescriptionDocumentKey(): MedicalPrescriptionDocumentKey {
    return this.medicalPrescriptionDocumentKey;
  }

  public hasDocumentKey(): boolean {
    return !!this.medicalPrescriptionDocumentKey && !!this.medicalPrescriptionDocumentKey.getValue();
  }

  public getMedicalPrescriptionDocument(): string {
    return this.MedicalPrescriptionDocument;
  }

  /**
   *
   * @param MedicalPrescriptionDocument blob da imagem
   */
  public setMedicalPrescriptionDocument(MedicalPrescriptionDocument: string): void {
    this.MedicalPrescriptionDocument = "data:image/png;base64," + MedicalPrescriptionDocument;
  }

  public getMedicalPrescriptionScanUrl(): string {
    return this.medicalPrescriptionScanUrl;
  }

  public setMedicalPrescriptionScanUrl(medicalPrescriptionScanUrl: string): void {
    this.medicalPrescriptionScanUrl = medicalPrescriptionScanUrl;
  }

  public getMedicalPrescriptionStatus(): string {
    return this.medicalPrescriptionStatus;
  }

  public setMedicalPrescriptionStatus(medicalPrescriptionStatus: string): void {
    this.medicalPrescriptionStatus = medicalPrescriptionStatus;
  }
}
